// extracted by mini-css-extract-plugin
export default {"EmojiBox":"Intro_EmojiBox__l1KKd","move":"Intro_move__+0B9y","grow":"Intro_grow__oacqv"};